import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxCommentCaptionsComponent } from './comment-captions.component';

export const ngxCommentCaptionsModule = angular.module('ngxCommentCaptionsModule', [])
	.directive('ngxCommentCaptions', downgradeComponent({component: NgxCommentCaptionsComponent}))
	.name;
